module.exports = __webpack_public_path__ + "img/bg4.66db6f36.jpg";